// packages/api-client/queries/judgingProgrammeQuestions/index.ts
import { useQuery } from "@tanstack/react-query";
export const createJudgingProgrammeQuestionsQueries = (requests, queryClient) => ({
    useFindJudgingProgrammeQuestion: (params, options = {}) => useQuery({
        queryKey: ["judging-programme-question", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findJudgingProgrammeQuestion(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map